import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { CoreModule, FlexLayoutModule } from '@angular/flex-layout';
import { AngularMaterialModule } from '../material/angular-material.module';
import { SharedModule } from '../shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { dashboardEffects, dashboardReducers } from './state';
import { EffectsModule } from '@ngrx/effects';
import { CoreModule as CustomCoreModule } from '../core/core.module';
import { ReactiveComponentModule } from '@ngrx/component';
import { dashboardFeatureKey } from './state/dashboard.selectors';
import {CalendarDateFormatter, CalendarModule, DateAdapter} from "angular-calendar";
import {adapterFactory} from "angular-calendar/date-adapters/date-fns";
import {CustomDateFormatter} from "./studies/components/esm-calender/custom-date-formatter";

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    DashboardRoutingModule,
    FlexLayoutModule,
    AngularMaterialModule.forRoot(),
    SharedModule,
    CustomCoreModule,
    StoreModule.forFeature(dashboardFeatureKey, dashboardReducers),
    EffectsModule.forFeature(dashboardEffects),
    ReactiveComponentModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  providers: [TitleCasePipe, {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter
    }],
})
export class DashboardModule {}
